goog.provide("shadow.js.shim.module$proj4");
goog.provide("module$shadow_js_shim_module$proj4");
shadow.js.shim.module$proj4 = shadow.js.nativeProvides["proj4"] = shadow$bridge("proj4");
module$shadow_js_shim_module$proj4.default = shadow.js.shim.module$proj4;
